module.exports = [
    {
        "key": "AL",
        "name": "Alabama",
        "programs": [
            1,
            2,
            3,
            5
        ],
        "url": "http://www.hardesthitalabama.com"
    },
    {
        "key": "AZ",
        "name": "Arizona",
        "programs": [
            1,
            2,
            3,
            4,
            5,
            6
        ],
        "url": "http://www.azhousing.gov"
    },
    {
        "key": "CA",
        "name": "California",
        "programs": [
            1,
            2,
            3,
            4,
            5
        ],
        "url": "http://keepyourhomecalifornia.org"
    },
    {
        "key": "DC",
        "name": "District of Columbia",
        "url": "https://www.homesaverdc.org/",
        "programs": []
    },
    {
        "key": "FL",
        "name": "Florida",
        "programs": [
            1,
            3,
            4
        ],
        "url": "https://www.flhardesthithelp.org"
    },
    {
        "key": "GA",
        "name": "Georgia",
        "programs": [
            1,
            2,
            3,
            4
        ],
        "url": "https://www.homesafegeorgia.com"
    },
    {
        "key": "IL",
        "name": "Illinois",
        "url": "https://www.illinoishardesthit.org/",
        "programs": []
    },
    {
        "key": "IN",
        "name": "Indiana",
        "programs": [
            1,
            2,
            3,
            4,
            5
        ],
        "url": "http://www.877gethope.org/about"
    },
    {
        "key": "KY",
        "name": "Kentucky",
        "programs": [
            1,
            3
        ],
        "url": "http://protectmykyhome.org"
    },
    {
        "key": "MI",
        "name": "Michigan",
        "programs": [],
        "url": "https://www.stepforwardmichigan.org"
    },
    {
        "key": "MS",
        "name": "Mississippi",
        "programs": [
            1,
            3
        ],
        "url": "https://www.mshomesaver.com"
    },
    {
        "key": "NV",
        "name": "Nevada",
        "programs": [
            2,
            3,
            4,
            6
        ],
        "url": "http://nevadahardesthitfund.nv.gov"
    },
    {
        "key": "NJ",
        "name": "New Jersey",
        "url": "http://www.njhomekeeper.gov/",
        "programs": [
          1,
          2,
          3,
          4
        ]
    },
    {
        "key": "NC",
        "name": "North Carolina",
        "programs": [
            1,
            2,
            3,
            4,
            6,
            7
        ],
        "url": "http://www.ncforeclosureprevention.gov"
    },
    {
        "key": "OH",
        "name": "Ohio",
        "url": "http://ohiohome.org/savethedream/",
        "programs": []
    },
    {
        "key": "OR",
        "name": "Oregon",
        "url": "http://www.oregonhomeownerhelp.org/",
        "programs": []
    },
    {
        "key": "RI",
        "name": "Rhode Island",
        "url": "http://www.hhfri.org/",
        "programs": []
    },
    {
        "key": "SC",
        "name": "South Carolina",
        "programs": [
            1,
            2,
            3,
            5
        ],
        "url": "http://www.scmortgagehelp.com"
    },
    {
      "key":"TN",
        "name": "Tennessee",
        "url": "http://www.keepmytnhome.org/",
        "programs": []
    }
].sort(function(rowA, rowB){
  var sortValue = 0, sortBy = 'name';

  if (rowA[sortBy] > rowB[sortBy]) {
    sortValue = 1;
  }

  if (rowA[sortBy] < rowB[sortBy]) {
    sortValue = -1;
  }

  return sortValue;
});



//////////////////
// WEBPACK FOOTER
// ./test/testStates.js
// module id = 25
// module chunks = 0